<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <multiselect
                        :options="optionDepartments"
                        v-model="search.departments"
                        class="form-control border-0"
                        label="department_name"
                        select-label=""
                        deselectLabel=""
                        placeholder="เลือกแผนก"
                        track-by="id">
                    </multiselect>
                    <multiselect
                        :customLabel="employeeLabel"
                        :options="optionEmployee"
                        class="form-control border-0"
                        deselectLabel=""
                        placeholder="พนักงาน"
                        select-label=""
                        track-by="id"
                        v-model="search.employee">
                    </multiselect>
                    <b-form-select
                        :options="optionActive"
                        v-model="search.active">
                    </b-form-select>
                    &nbsp;&nbsp;
                    <b-select :options="optionDepartment" v-model="search.department"></b-select>
                    &nbsp;&nbsp;
                    <b-select :options="employee_type" v-model="search.employee_type"></b-select>
                    &nbsp;&nbsp;
                    <date-picker
                        format="DD/MM/YYYY"
                        lang="en"
                        placeholder="วันที่ปรับ"
                        type="date"
                        v-model="search.date">
                    </date-picker>
                    &nbsp;
                    <button @click="searchSalaryHistory"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp;
                    <router-link to="employee-salary-form">
                        <button class="btn btn-warning my-2 my-sm-0"
                                type="button">
                            <icon name="plus"></icon>
                            ปรับเงินเดือน
                        </button>
                    </router-link>
                    &nbsp;
                    <button @click="report('pdf')"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        รายงานปรับเงิน(PDF)
                    </button>
                    &nbsp;
                    <button @click="report('excel')"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        รายงานปรับเงิน(Excel)
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered" style="text-align: center">
                <thead>
                <tr>
                    <th scope="col">รหัสพนักงาน</th>
                    <th scope="col">ชื่อพนักงาน</th>
                    <th scope="col">ประเภทพนักงาน</th>
                    <th scope="col">แผนก</th>
                    <th scope="col">ปรับค่าจ้างเป็น</th>
                    <th scope="col">ปรับเบี้ยขยัน(ครึ่งเดือน)เป็น</th>
                    <th scope="col">วัน/เดือน/ปี ที่ปรับ</th>
                    <th scope="col">ผู้ปรับ</th>
                    <th scope="col">อนุมัติ</th>
                    <th scope="col">ผู้อนุมัติ</th>
                    <th scope="col">วัน/เดือน/ปี ที่อนุมัติ</th>
                    <th scope="col">แก้ไข/ลบ</th>
                </tr>
                </thead>
                <tbody>
                <template v-for="(data,index) in salaryHistoryList">
                    <tr>
                        <td>{{data.employee.employee_no}}</td>
                        <td>{{data.employee.name}}</td>
                        <td>
                            <template v-if="data.employee.occupation && data.employee.occupation.type">
                                {{data.employee.occupation.type.name}}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <template v-if="data.employee.occupation && data.employee.occupation.position">
                                {{data.employee.occupation.position.name}}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td :class="{'text-green':data.rate_salary == 'up','text-red':data.rate_salary == 'down'}">
                            {{data.salary ? data.salary : '-'}}
                        </td>
                        <td :class="{'text-green':data.rate_benefit == 'up','text-red':data.rate_benefit == 'down'}">
                            {{data.benefit ? data.benefit : '-'}}
                        </td>
                        <td>
                            {{data.updated_at | moment("DD-MM-YYYY H:m")}}
                        </td>
                        <td>
                            <span v-if="data.user">{{data.user.name}}</span>
                            <template v-else>-</template>
                        </td>
                        <td>
                            <span v-if="canViewSuperAdmin && !data.status" @click="showApproveModal(data.id)" style="text-decoration: underline;color: red;cursor: pointer">รอการอนุมัติ</span>
                            <span v-else-if="!canViewSuperAdmin && !data.status" style="text-decoration: underline;color: red;cursor: pointer">รอการอนุมัติ</span>
                            <span v-else style="color: green;">อนุมติแล้ว</span>
                        </td>
                        <td>
                            {{data.approved && data.approved.name}}
                        </td>
                        <td>
                            {{data.status_date ? data.status_date : '' | moment("DD-MM-YYYY H:m")}}
                        </td>
                        <td>
                            <a v-if="!data.status" @click="showModal(data.id)">
                                <icon name="pencil-alt"></icon>
                            </a>
                            &nbsp;&nbsp;
                            <a @click="showDeleteModal(data.id)">
                                <icon name="trash"></icon>
                            </a>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </div>
        <br>
        <div v-if="salaryHistoryList.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getSalaryHistory">

            </vue-pagination>
        </div>
        <b-modal hide-footer hide-header ref="delete_modal">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br/>
                <button @click="delete_confirm"
                        class="btn btn-success"
                        type="button">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="hideDeleteModal"
                        class="btn btn-outline-secondary"
                        type="button">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <b-modal hide-footer hide-header ref="detail_modal">
            <div class="row" style="text-align: center;">
                <div class="col-12">
                    <h4>รายละเอียดเงินเดือนพนักงาน</h4>
                </div>
                <div class="col-12">
                    <p>ชื่อพนักงน : {{modal_detail.employee?modal_detail.employee.name:''}}</p>
                </div>
                <div class="col-12">
                    <p>แผนก : {{modal_detail.employee?modal_detail.employee.occupation.department.department_name:''}}</p>
                </div>
                <div class="col-12 row">
                    <b-col class="col-3 text-right">รายได้</b-col>
                    <b-col class="col-9">
                        <input class="form-control"
                               v-model="modal_detail.salary"
                               type="number"/>
                    </b-col>
                    <br/>
                    <br/>
                </div>
                <div class="col-12 row">
                    <b-col class="col-6">
                        <button @click="change_confirm"
                                type="button"
                                class="btn btn-success">
                            ตกลง
                        </button>
                    </b-col>
                    <b-col class="col-6">
                        <button type="button"
                                @click="hideModal"
                                class="btn btn-outline-secondary">
                            ยกเลิก
                        </button>
                    </b-col>
                </div>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="approve" centered>
            <confirm-modal msg="คุณต้องการอนุมัติพนักงานใช่หรือไม่ ?" @submit="approveSalary">
            </confirm-modal>
        </b-modal>
        <!--<pre class="alert alert-primary">{{salaryHistoryList}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex"
import moment from "moment";
import DatePicker from 'vue2-datepicker'
import Multiselect from "vue-multiselect";
import VuePagination from "../../../Pagination";
import {canViewSuperAdmin} from "../../../../util/Permissions";
import {domain} from "@/util/Constants";
import ConfirmModal from "../../../Utility/ConfirmModal";

export default {
        components: {
            VuePagination,
            DatePicker,
            Multiselect,
            ConfirmModal
        },
        name: "rate-salary",
        created() {
            this.$store.dispatch("RateSalaryHistory/setRateSalaryHistory")
            this.$store.dispatch("RateSalaryHistory/clearSearch");
            this.getEmployeeAll();
            this.getDepartmentAll();
            this.$store.dispatch("Department/getAllDepartment").then(res=>{
                this.optionDepartments = res;
            })
        },
        computed: {
            canViewSuperAdmin,
            ...mapState({
                salaryHistoryList: state => {
                    return state.RateSalaryHistory.salaryHistoryList;
                },
                search: state => {
                    return state.RateSalaryHistory.search;
                },
                dataPaginate: state => {
                    return state.RateSalaryHistory.dataPaginate;
                },
                modal_detail: state => {
                    return state.Employee.modal_salary_detail;
                },
                user: state => {
                    return state.Auth.user;
                },
                optionDepartment: state => {
                    return [
                        {
                            value: "",
                            text: "ค้นหาประเภท"
                        },
                        ...state.Common.position.map(status => ({
                            value: status.id,
                            text: status.name
                        }))
                    ]
                }
            })
        },
        data() {
            return {
                event_submit: false,
                optionEmployee: [],
                delete_id: '',
                optionDepartments: [],
                employee_type: [
                    {
                        value: "",
                        text: "ค้นหาประเภทพนักงาน"
                    },
                    {
                        value: 1,
                        text: "ประจำ"
                    },
                    {
                        value: 2,
                        text: "รายวัน"
                    },
                ],
                optionActive : [
                    {text:"เลือกสถานะ",value:""},
                    {text:'พนักงาน',value:1},
                    {text:'ลาออก',value:2},
                ],
                salary_id : ''
            }
        },
        methods: {
            showModal(id) {
                this.$store.dispatch("Employee/detailSalary", id).then(() => {
                    this.$refs.detail_modal.show();
                })
            },
            hideModal() {
                this.$refs.detail_modal.hide();
            },
            change_confirm() {
                let data = {
                    salary: this.modal_detail.salary,
                    id: this.modal_detail.id
                };
                this.$store.dispatch("Employee/updateSalary", data).then(() => {
                    this.hideModal();
                    this.getSalaryHistory()
                })
            },
            showApproveModal(id){
                this.salary_id = id;
                this.$refs.approve.show();
            },
            hideApproveModal(){
                this.$refs.approve.hide();
            },
            approveSalary(value){
                if (value)
                    this.$store.dispatch('Employee/approveSalary', {'id':this.salary_id,'user_id':this.user.id}).then(()=>this.getSalaryHistory());
            },
            showDeleteModal(id) {
                this.delete_id = id;
                this.$refs.delete_modal.show();
            },
            hideDeleteModal() {
                this.$refs.delete_modal.hide();
            },
            delete_confirm() {
                this.$store.dispatch('Employee/deleteSalary',this.delete_id).then(res=>{
                    this.hideDeleteModal();
                    this.getSalaryHistory()
                })
            },
            getDepartmentAll() {
                this.$store.dispatch("Common/setPosition");
            },
            employeeLabel(option) {
                return `${option.employee_no} - ${option.name}`
            },
            getEmployeeAll() {
                this.$store.dispatch("Employee/getEmployeeAll").then(res => {
                    this.optionEmployee = res;
                })
            },
            salaryRateForm() {
                this.$store.dispatch("Employee/getEmployeeAll").then(res => {
                    this.optionEmployee = res;
                })
            },
            searchSalaryHistory() {
                this.event_submit = true;
                let data = {
                    employee_id: this.search.employee ? this.search.employee.id : '',
                    employee_type: this.search.employee_type,
                    department: this.search.department,
                    departments: this.search.departments?this.search.departments.id:'',
                    date: this.search.date ? moment(this.search.date).format("YYYY-MM-DD") : null,
                    active: this.search.active
                };
                this.$store.dispatch("RateSalaryHistory/search", data)
            },
            getSalaryHistory() {
                const page = this.dataPaginate.current_page;

                //change date format
                if (this.search.created_at) {
                    this.search.created_at = moment(this.search.created_at).format("YYYY-MM-DD");
                } else {
                    this.search.created_at = "";
                }

                let data = {
                    page: page,
                    employee_type: this.search.employee_type,
                    department: this.search.department,
                    created_at: this.search.created_at,
                }

                this.hideApproveModal();

                //paginate search
                if (this.event_submit) {
                    this.$store.dispatch('RateSalaryHistory/search', data)
                }
                //paginate get data
                else {
                    this.$store.dispatch('RateSalaryHistory/setRateSalaryHistory', page)
                }
            },
            report(type){

                let data = {
                    employee_id: this.search.employee ? this.search.employee.id : '',
                    employee_type: this.search.employee_type,
                    department: this.search.department,
                    date: this.search.date ? moment(this.search.date).format("YYYY-MM-DD") : null,
                    active: this.search.active
                };

                let url = domain + `/report_rate_salary?employee_id=${data.employee_id}&type=${type}&employee_type=${data.employee_type}&department=${data.department}&active=${data.active}&created_at=${data.date}`

                window.open(url,'_blank')
            }
        }
    }
</script>

<style scoped>
.text-green{
    color: green;
}
.text-red{
    color: red;
}
</style>
